import React from "react";
import styled from "styled-components";
import { cherry, red, cloud } from "@vitalsource/vstui/colors";

const GrayBlock = styled.div`
  margin: 10px 0;
  border-radius: 4px;
  background: ${cloud.getShade(3)};
  padding: 18px;
  & > *:first-child {
    margin-top: 0;
  }
`;

const StyledFormError = styled.div`
  background: ${red.getShade(3)};
  border: 2px solid ${cherry.getShade(1)};
  padding: 16px;
  margin: 10px 0;
  border-radius: 4px;
`;

export class FormAlert extends React.PureComponent {
  componentDidMount() {
    this.formAlert.focus();
  }
  renderWarning() {
    return (
      <GrayBlock tabIndex={-1} innerRef={x => (this.formAlert = x)}>
        {this.props.children}
      </GrayBlock>
    );
  }
  renderError() {
    return (
      <StyledFormError tabIndex={-1} innerRef={x => (this.formAlert = x)}>
        {this.props.children}
      </StyledFormError>
    );
  }
  render() {
    switch (this.props.level) {
      case "info":
      case "warning":
      case "debug":
        return this.renderWarning();
      case "error":
      case "fatal":
        return this.renderError();
      default:
        return this.renderWarning();
    }
  }
}

export default FormAlert;
